import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import "./Licence.css";
import { Link, useLocation } from "react-router-dom";

const SmsTerms = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isWebView = searchParams.get("webview") === "true";

  return (
    <div>
      <div className="container MainTagSpace">
        <div>
          {!isWebView && <Header />}
          <div className="container">
            <div className="row">
              <div className="col-lg-12 pt-4">
                <div className="pt-4">
                  <h2>SMS TERMS &amp; CONDITIONS</h2>
                </div>

                <div className="py-2">
                  <b>Brand / Service:</b> Genwe<br />
                  <b>Operated by:</b> Generationwe Private Limited
                </div>

                <div className="py-2">
                  Genwe is operated by Generationwe Private Limited. We provide SMS
                  notifications to users who have registered and provided their
                  mobile telephone numbers for the specific transactional purposes
                  described below.
                </div>

                <div className="py-2 h5">
                  <b>1. Program Description &amp; SMS Use Cases</b>
                </div>
                <div className="py-2">
                  Genwe uses SMS text messaging solely for transactional and
                  essential account communications, including:
                  <ul>
                    <li>One-Time Passwords (OTPs) for mobile number verification</li>
                    <li>Account authentication and login verification</li>
                    <li>Critical security alerts and account status notifications</li>
                  </ul>
                  <b>Strict No Marketing / No Affiliate Policy:</b> Genwe SMS
                  communications are strictly transactional. We do not use SMS for
                  marketing, promotional campaigns, affiliate marketing, or lead
                  generation.
                </div>

                <div className="py-2 h5">
                  <b>2. Message Frequency</b>
                </div>
                <div className="py-2">
                  Message frequency varies depending on your user account activity,
                  login requests, and verification attempts. Typically, SMS messages
                  are only triggered when you request an OTP or experience security-related
                  account events.
                </div>

                <div className="py-2 h5">
                  <b>3. Message and Data Rates</b>
                </div>
                <div className="py-2">
                  Message and data rates may apply for any messages sent to you from
                  us and to us from you. If you have any questions about your text plan
                  or data plan, please contact your wireless provider.
                </div>

                <div className="py-2 h5">
                  <b>4. How to Opt Out (STOP)</b>
                </div>
                <div className="py-2">
                  You can cancel the SMS service at any time. Simply text <b>STOP</b>{" "}
                  in reply to any text message you receive from us. After you send the
                  SMS message <b>STOP</b> to us, we will send you an SMS message to
                  confirm that you have been unsubscribed. After this, you will no
                  longer receive SMS messages from us. If you want to join again, sign
                  in as you did the first time and we will resume sending SMS for OTP
                  and verification.
                </div>

                <div className="py-2 h5">
                  <b>5. How to Get Help (HELP)</b>
                </div>
                <div className="py-2">
                  If you are experiencing issues with the messaging program you can reply
                  with the keyword <b>HELP</b> for more assistance, or you can get help
                  directly at <b>friends@genwe.today</b>.
                </div>

                <div className="py-2 h5">
                  <b>6. Privacy and Mobile Data Protection</b>
                </div>
                <div className="py-2">
                  Your privacy is important to us. Mobile phone numbers, SMS opt-in
                  consent, and messaging data will strictly <b>NOT</b> be sold,
                  rented, or shared with third parties or affiliates for their own
                  marketing or promotional purposes.
                </div>

                <div className="py-2 h5">
                  <b>7. Related Legal Policies</b>
                </div>
                <div className="py-2">
                  For further details regarding how we protect your personal information
                  and govern the use of our services, please review our:
                  <ul>
                    <li>
                      <Link to={isWebView ? "/PrivacyPolicy" : "/DexTopPrivacyPolicy"}>
                        Privacy Policy
                      </Link>
                    </li>
                    <li>
                      <Link to={isWebView ? "/LicenceAgreement" : "/DeskTopLicenceAgreement"}>
                        Terms of Use / End User License Agreement
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="py-2 h5">
                  <b>8. Contact Us</b>
                </div>
                <div className="py-2 pb-4">
                  If you have any questions about these SMS Terms, please contact
                  Generationwe Private Limited at <b>friends@genwe.today</b>.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {!isWebView && (
        <div className="FooterMargin">
          <Footer />
        </div>
      )}
    </div>
  );
};

export default SmsTerms;
